/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { ContainerItem } from "store";

const generateId = () =>
  Math.floor((1 + Math.random()) * 0x100000)
    .toString(16)
    .substring(0);

export const colors: any = [
  "#EB8B8B",
  "#DF4545",
  "#D40000",
  "#B40000",
  "#FCEA90",
  "#FBDE4E",
  "#FAD20C",
  "#B69909",
  "#F6BB90",
  "#EF8030",
  "#ED6A0C",
  "#C95A0A",
  "#FCD890",
  "#FBC14E",
  "#FAAB0C",
  "#B67D09",
  "#C7E58B",
  "#A6D645",
  "#85c700",
  "#619100",
  "#9FD6A8",
  "#4CB35D",
  "#2DA641",
  "#268D37",
  "#92D3D9",
  "#51B9C3",
  "#11A0AD",
  "#0D757E",
  "#96C9FC",
  "#57A9FB",
  "#1989FA",
  "#1364B6",
  "#94B4EB",
  "#3773DA",
  "#155BD4",
  "#114DB4",
  "#A3A3C8",
  "#6C6CA7",
  "#363687",
  "#282863",
  "#C9A7EB",
  "#A973DF",
  "#8A3FD4",
  "#652E9B",
  "#EB9ECB",
  "#DF64AC",
  "#D42A8D",
  "#9B1F67",
];

export const auto_containers: ContainerItem[] = [
  {
    uid: generateId(),
    attr: {
      type: "20st",
    },
    spaces: [
      {
        length: 5890,
        width: 2350,
        height: 2390,
        maxWeight: 28230,
      },
    ],
    loadType: "auto",
    groups: [],
  },
  {
    uid: generateId(),
    attr: {
      type: "40st",
    },
    spaces: [
      {
        length: 12020,
        width: 2350,
        height: 2390,
        maxWeight: 26700,
      },
    ],
    loadType: "auto",
    groups: [],
  },
  {
    uid: generateId(),
    attr: {
      type: "40hq",
    },
    spaces: [
      {
        length: 12020,
        width: 2350,
        height: 2690,
        maxWeight: 26460,
      },
    ],
    loadType: "auto",
    groups: [],
  },
];

export const pallet_types: any = {
  euro: {
    uid: generateId(),
    color: "#000",
    size: {
      length: 1200,
      width: 800,
      height: 2000,
    },
    stacking: {
      // square/hex - 6
      rollPlacement: 4,
      loadType: "auto",
      // 0-1
      fill: 1,
      layers: 10,
      sortOrder: "auto",
    },
    weight: 10,
    maxWeight: 1500,
    depth: 100,
    name: "euro",
    type: "euro",
  },
  euroHalf: {
    uid: generateId(),
    color: "#000",
    size: {
      length: 600,
      width: 800,
      height: 2000,
    },
    stacking: {
      // square/hex - 6
      rollPlacement: 4,
      loadType: "auto",
      // 0-1
      fill: 1,
      layers: 10,
      order: "auto",
    },
    weight: 10,
    maxWeight: 1300,
    depth: 100,
    name: "Europe 1/2 Pallets",
    type: "euroHalf",
  },
  euroPlastic: {
    uid: generateId(),
    color: "#000",
    size: {
      length: 1200,
      width: 800,
      height: 2000,
    },
    stacking: {
      // square/hex - 6
      rollPlacement: 4,
      loadType: "auto",
      // 0-1
      fill: 1,
      layers: 10,
      order: "auto",
    },
    weight: 10,
    maxWeight: 1300,
    depth: 100,
    name: "Europe Plastic Pallets",
    type: "euroPlastic",
  },
  us: {
    uid: generateId(),
    color: "#000",
    size: {
      length: 1200,
      width: 1000,
      height: 2000,
    },
    stacking: {
      // square/hex - 6
      rollPlacement: 4,
      loadType: "auto",
      // 0-1
      fill: 1,
      layers: 10,
      order: "auto",
    },
    weight: 10,
    maxWeight: 750,
    depth: 100,
    name: "us",
    type: "us",
  },
  custom: {
    uid: generateId(),
    color: "#000",
    size: {
      length: 100,
      width: 100,
      height: 100,
    },
    stacking: {
      // square/hex - 6
      rollPlacement: 4,
      loadType: "auto",
      // 0-1
      fill: 1,
      layers: 10,
      order: "auto",
    },
    weight: 10,
    maxWeight: 1500,
    depth: 100,
    name: "custom",
    type: "custom",
  },
};

export const container_types: any = [
  {
    name: "20' STANDARD",
    value: "20st",
    disabled: false,
  },
];

export const units: any = {
  lengthUnits: [
    {
      name: "Millimeters",
      value: "mm",
    },
    {
      name: "Meters",
      value: "m",
    },
    {
      name: "Foots",
      value: "fts",
    },
    {
      name: "Inches",
      value: "inch",
    },
  ],
  weightUnits: [
    {
      name: "Kilograms",
      value: "kg",
    },
    {
      name: "Pounds",
      value: "lb",
    },
  ],
};

export const pallets: any = [
  {
    name: "Europe Pallets",
    value: "euro",
  },
  {
    name: "Europe 1/2 Pallets",
    value: "euroHalf",
  },
  {
    name: "Europe Plastic Pallets",
    value: "euroPlastic",
  },
  {
    name: "US Pallets",
    value: "us",
  },
  {
    name: "Custom Pallets",
    value: "custom",
  },
];

export const loading_rules: any = [
  {
    name: "Auto",
    value: "auto",
  },
  {
    name: "Wall Length",
    value: "wallLength",
  },
  {
    name: "Wall Width",
    value: "wallWidth",
  },
  {
    name: "Floor",
    value: "floor",
  },
];

export const pallet_sort_order: any = [
  {
    name: "Auto",
    value: "auto",
  },
  {
    name: "↓ Volume",
    value: "volume_asc",
  },
  {
    name: "↑ Volume",
    value: "volume_desc",
  },
  {
    name: "↓ Square",
    value: "square_asc",
  },
  {
    name: "↑ Square",
    value: "square_desc",
  },
  {
    name: "↓ MPS (Mass per Square)",
    value: "mps_asc",
  },
  {
    name: "↑ MSP (Mass per Square)",
    value: "mps_desc",
  },
  {
    name: "↓ MPV (Mass per Volume)",
    value: "mpv_asc",
  },
  {
    name: "↑ MPV (Mass per Volume)",
    value: "mpv_desc",
  },
];

export const trucks_types: any = [
  {
    name: "FTL Less 86",
    value: "FTL_Less_86",
    disabled: false,
  },
  {
    name: "FTL 86",
    value: "FTL_86",
    disabled: false,
  },
  {
    name: "FTL 90",
    value: "FTL_90",
    disabled: false,
  },
  {
    name: "FTL 120",
    value: "FTL_120",
    disabled: false,
  },
  {
    name: "FTL 150",
    value: "FTL_150",
    disabled: false,
  },
];
